import Alpine from 'alpinejs';

import ui from 'alpineUi';
import collapse from 'alpineCollapse';
import focus from 'alpineFocus';
import morph from 'alpineMorph';
import persist from 'alpinePersist';
import ajax from 'alpineAjax';

import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiperModules';

import { ajaxLink, sanitize, slugify, translate } from './alpine-directives/index.js';
import { autocomplete, placesAutocomplete, favourites, fileUpload, validator, jobalert } from './alpine-components/index.js';
import { cookieStorage } from './utilities/cookieStorage.js';
import { validationSuites } from './validation-suites/index.js';

/* Register plugins */
Alpine.plugin(ui);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(morph);
Alpine.plugin(persist);
Alpine.plugin(ajax);

/* Register directives */
Alpine.directive('ajax-link', ajaxLink);
Alpine.directive('sanitize', sanitize);
Alpine.directive('slugify', slugify);
Alpine.directive('translate', translate);

/* Register components */
Alpine.data('autocomplete', autocomplete);
Alpine.data('placesAutcomplete', placesAutocomplete);
Alpine.data('favourites', favourites);
Alpine.data('fileUpload', fileUpload);
Alpine.data('jobalert', jobalert);
Alpine.data('validator', validator);

/* Initialize */
window.validationSuites = validationSuites;
window.cookieStorage = cookieStorage;
window.Swiper = Swiper;
window.SwiperModules = { pagination: Pagination, navigation: Navigation };

window.Alpine = Alpine;
window.Alpine.start();
